/* deSal — free mystery-gift cart add-on.
   When the cart subtotal (excluding the gift itself) is >= the threshold, a
   free (₹0) mystery gift is auto-added. The shopper can remove it; once removed
   it is NOT re-added (tracked via cart attributes). Drops back off below the
   threshold. Mirrors the retired desal-tds-meter.js engine, but the gift is free
   instead of a ₹1 paid add-on. */
(function () {
  if (window.__desalGiftInit) return;
  window.__desalGiftInit = true;

  // Variant id comes from Shopify admin via desal-cart-extras.liquid
  // (window.DESAL_GIFT_VARIANT). Falls back only if the snippet didn't set it.
  var VARIANT = Number(window.DESAL_GIFT_VARIANT) || 0;
  var THRESHOLD = Number(window.DESAL_GIFT_THRESHOLD) || 99900; // paise — qualifies when subtotal >= ₹999
  if (!VARIANT) return; // no mystery-gift product configured — do nothing
  var running = false;

  function getGift(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === VARIANT) return cart.items[i];
    }
    return null;
  }
  function subtotalExclGift(cart) {
    var t = 0;
    cart.items.forEach(function (i) { if (i.variant_id !== VARIANT) t += i.final_line_price; });
    return t;
  }
  function attr(cart, k) { return cart.attributes && cart.attributes[k] === 'true'; }
  // fetch + JSON with an abort timeout so a slow/hung request never blocks the
  // cart (and never leaves checkout locked). Default 8s.
  function getJSON(url, opts, timeoutMs) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var id = ctrl ? setTimeout(function () { ctrl.abort(); }, timeoutMs || 8000) : 0;
    var o = opts ? Object.assign({}, opts) : {};
    if (ctrl) o.signal = ctrl.signal;
    return fetch(url, o)
      .then(function (r) { return r.json(); })
      .then(function (v) { if (id) clearTimeout(id); return v; },
            function (e) { if (id) clearTimeout(id); throw e; });
  }
  // Run thunk, retrying up to `attempts` times total on failure/timeout.
  function withRetry(thunk, attempts) {
    return thunk().catch(function (e) {
      if (attempts > 1) return withRetry(thunk, attempts - 1);
      throw e;
    });
  }
  function setAttrs(a) {
    return getJSON('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: a })
    });
  }
  function change(key, qty) {
    return getJSON('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }
  function notify(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: 'desal-mystery-gift', data: { itemCount: cart.item_count, source: 'desal-gift' } }
    }));
  }
  function onCartPage() { return window.location.pathname.indexOf('/cart') === 0; }
  // No full-page reload — it freezes the whole drawer/page. notify() re-renders
  // the cart softly instead; only the checkout button is locked during the op.
  function reloadIfCart() {}
  // Lock checkout while the gift is being added/removed so the shopper can't
  // reach checkout in a half-updated cart. CSS (desal-cart-extras.liquid) reads
  // the .desal-cart-busy class and disables the checkout buttons.
  // Lock checkout while adding/removing the gift — but DEBOUNCED. Most gift ops
  // finish in a few hundred ms; flashing the checkout button grey-then-black for
  // that blink looks buggy. So we only actually apply the lock if the op is
  // still running after a short grace period, and clear it the moment we finish.
  var busyTimer = null;
  function setBusy(on) {
    if (on) {
      if (busyTimer || document.documentElement.classList.contains('desal-cart-busy')) return;
      busyTimer = setTimeout(function () {
        busyTimer = null;
        document.documentElement.classList.add('desal-cart-busy');
      }, 400);
    } else {
      if (busyTimer) { clearTimeout(busyTimer); busyTimer = null; }
      document.documentElement.classList.remove('desal-cart-busy');
    }
  }

  // Keep the drawer dialog's `cart-drawer--empty` class in sync with the real
  // cart. Horizon stamps that class once at render ({% if cart.empty? %}); when
  // you add to a cart that loaded empty, only the inner cart-items content
  // morphs, so the class lingers on a now-full cart and its empty layout
  // (content height:auto, centred) kills scrolling on mobile until a refresh.
  function syncEmptyClass(cart) {
    if (!cart) return;
    var dialog = document.querySelector('.cart-drawer__dialog');
    if (!dialog) return;
    var count = typeof cart.item_count === 'number'
      ? cart.item_count
      : (cart.items ? cart.items.length : null);
    if (count === null) return;
    dialog.classList.toggle('cart-drawer--empty', count === 0);
  }

  // ── Checkout guard ─────────────────────────────────────────────────────────
  // You must never be able to check out with ONLY the free gift (a ₹0 order).
  // When the cart holds the gift but no paid items, block checkout immediately —
  // we evaluate this synchronously from the cart carried on each cart:update
  // event, so it does NOT wait for the (sometimes slow) gift-removal round-trip.
  function setCheckoutBlocked(blocked) {
    window.__desalCheckoutBlocked = !!blocked;
    document.documentElement.classList.toggle('desal-no-checkout', !!blocked);
  }
  function evaluateCheckout(cart) {
    if (!cart || !cart.items) return;
    var nonGift = 0, hasGift = false;
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === VARIANT) hasGift = true;
      else nonGift += cart.items[i].quantity;
    }
    setCheckoutBlocked(hasGift && nonGift === 0);
  }

  function sync(cartHint) {
    if (running) return;
    running = true;
    var cartP = (cartHint && cartHint.items && cartHint.attributes) ? Promise.resolve(cartHint) : getJSON('/cart.js');
    cartP.then(function (cart) {
      evaluateCheckout(cart);
      syncEmptyClass(cart);
      var gift = getGift(cart);
      var sub = subtotalExclGift(cart);
      var qualified = sub >= THRESHOLD;
      var removed = attr(cart, 'mystery_gift_removed');
      var added = attr(cart, 'mystery_gift_added');

      // Below threshold: pull the gift and reset the flags.
      if (!qualified) {
        if (gift) {
          setBusy(true);
          return change(gift.key, 0).then(function (cart) {
            running = false; setBusy(false);
            notify(cart); reloadIfCart();
            setAttrs({ mystery_gift_removed: '', mystery_gift_added: '' }); // reset flags in the background
          }).catch(function () { running = false; setBusy(false); });
        }
        if (removed || added) { return setAttrs({ mystery_gift_removed: '', mystery_gift_added: '' }).then(function () { running = false; }); }
        running = false; return;
      }

      // Qualified + gift present: ensure qty is exactly 1.
      if (gift) {
        if (gift.quantity !== 1) { return change(gift.key, 1).then(function () { running = false; getJSON('/cart.js').then(notify); }); }
        running = false; return;
      }

      // Qualified, no gift, shopper removed it → leave it off.
      if (removed) { running = false; return; }
      // Was auto-added before and is now gone (e.g. deleted via the trash icon)
      // → treat as a manual removal AND re-render, so the top strip flips to the
      // "Add it back" state instead of getting stuck on "Adding…".
      if (added) { return setAttrs({ mystery_gift_removed: 'true', mystery_gift_added: '' }).then(function (c) { running = false; notify(c); reloadIfCart(); }); }

      // Qualified, never added → add it. Give the add a 6s timeout and one retry;
      // if it still fails, SKIP the gift and release checkout rather than leaving
      // the cart stuck/locked.
      setBusy(true);
      withRetry(function () {
        return getJSON('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: VARIANT, quantity: 1, properties: { _addon: 'Free mystery gift 🎁' } }] })
        }, 6000);
      }, 2)
        // /cart/update.js returns the full updated cart, so reuse it directly
        // instead of an extra /cart.js round-trip — one less request before the
        // gift shows up.
        .then(function () { return setAttrs({ mystery_gift_added: 'true' }); })
        .then(function (c) { running = false; setBusy(false); notify(c); reloadIfCart(); })
        .catch(function () { running = false; setBusy(false); }); // timed out / failed → skip the gift
    }).catch(function () { running = false; });
  }

  window.desalRemoveMysteryGift = function () {
    setBusy(true);
    getJSON('/cart.js').then(function (cart) {
      var gift = getGift(cart);
      var p = gift ? change(gift.key, 0) : Promise.resolve(cart);
      p.then(function () { return setAttrs({ mystery_gift_removed: 'true', mystery_gift_added: '' }); })
        .then(function () { return getJSON('/cart.js'); })
        .then(function (c) { setBusy(false); notify(c); reloadIfCart(); })
        .catch(function () { setBusy(false); });
    }).catch(function () { setBusy(false); });
  };

  window.desalAddMysteryGift = function () {
    setAttrs({ mystery_gift_removed: '' }).then(function () { running = false; sync(); });
  };

  document.addEventListener('cart:update', function (e) {
    lockGiftQuantity();
    // Re-evaluate the checkout guard synchronously from the cart on the event,
    // so a "removed the last paid item" change locks checkout this instant.
    if (e.detail && e.detail.resource) {
      evaluateCheckout(e.detail.resource);
      syncEmptyClass(e.detail.resource);
    }
    if (e.detail && e.detail.sourceId === 'desal-mystery-gift') return;
    setTimeout(function () { sync(e.detail && e.detail.resource); }, 60);
  });

  // Hard guard: even if the button still looks active for a frame, a click /
  // keyboard activation on checkout is cancelled while the cart is gift-only.
  document.addEventListener(
    'click',
    function (e) {
      if (!window.__desalCheckoutBlocked) return;
      var btn = e.target && e.target.closest
        ? e.target.closest('[name="checkout"], #checkout, .cart__checkout-button')
        : null;
      if (btn) { e.preventDefault(); e.stopImmediatePropagation(); }
    },
    true
  );

  // Lock the free gift to a single unit. The theme handles the "+" via its own
  // capture-phase delegated listener (component.js), so racing it with another
  // listener is unreliable — the increment fires first. Instead we neutralise
  // the increment at the source: patch the cart quantity-selector's prototype
  // ONCE so increaseQuantity() is a no-op *only* for the gift's variant. Every
  // line (gift or not) shares this prototype, so this needs to succeed just
  // once and survives section morphs. No markup/CSS change — the stepper looks
  // identical, the gift's "+" simply does nothing. (sync() still snaps any
  // value typed straight into the input back to 1 as a safety net.)
  function lockGiftQuantity() {
    if (window.__desalGiftQtyLocked) return;
    var inst = document.querySelector('cart-quantity-selector-component');
    if (!inst || typeof inst.increaseQuantity !== 'function') return; // no cart line yet — retry later
    var proto = Object.getPrototypeOf(inst);
    if (!proto) return;
    var orig = inst.increaseQuantity;
    proto.increaseQuantity = function () {
      var vid = this.getAttribute && this.getAttribute('data-variant-id');
      if (Number(vid) === VARIANT) return; // free gift — capped at 1
      return orig.apply(this, arguments);
    };
    window.__desalGiftQtyLocked = true;
  }
  // If the cart already rendered in the "adding the gift" state, lock checkout
  // synchronously now so it can't be clicked before the add completes.
  function init() {
    if (document.querySelector('[data-gift-pending]')) setBusy(true);
    lockGiftQuantity();
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
